import React from 'react';
import { Box, Button } from '@mui/material';
import { MobileDatePickerProps } from './MobileDatePicker';
import { mobileYearPickerStyles } from './MobileYearPicker.styles';

const MobileYearPicker = (props: MobileDatePickerProps) => {
  const { startDate, endDate, selectedDay, setActiveDate, closeCalendarModal } = props;

  const currentDate = selectedDay || new Date();
  const currentYear = currentDate.getFullYear();

  // Generate years range based on min/max dates
  const minYear = startDate ? startDate.getFullYear() : currentYear - 2;
  const maxYear = endDate ? endDate.getFullYear() : currentYear + 2;

  const years = [];
  for (let year = minYear; year <= maxYear; year++) {
    years.push(year);
  }

  const onYearClick = (year: number) => {
    const newDate = new Date(year, 0, 1); // January 1st of selected year
    setActiveDate?.(newDate);
    closeCalendarModal?.();
  };

  const isYearSelected = (year: number) => {
    return year === currentYear;
  };

  const isYearDisabled = (year: number) => {
    const yearStart = new Date(year, 0, 1);
    const yearEnd = new Date(year, 11, 31);

    if (startDate && yearEnd < startDate) return true;
    if (endDate && yearStart > endDate) return true;
    return false;
  };

  return (
    <Box sx={mobileYearPickerStyles.wrapper} data-id={'OuterWrapper'}>
      {years.map(year => {
        const isSelected = isYearSelected(year);
        const isDisabled = isYearDisabled(year);

        return (
          <Button
            key={year}
            variant="text"
            disabled={isDisabled}
            onClick={() => onYearClick(year)}
            sx={
              isSelected
                ? mobileYearPickerStyles.selectedYearButton
                : mobileYearPickerStyles.yearButton
            }>
            {year}
          </Button>
        );
      })}
    </Box>
  );
};

export default MobileYearPicker;
